export default "__VITE_ASSET__Cbh_EqQH__"